import * as React from "react";
import { InvestInput } from "./BubbleStyles";

export const LinkView = (props) => {
  let split = props.payload.split("@@");
  let actionLink = getActionLink(split[0]);
  let label = split[1];
  if (props.tag.some((t) => t.code === "iframe")) {
    return <iframe src={actionLink} height="60" width="100%" title={label}></iframe>;
  }
  if (isLottoTermsButton(actionLink)) return lottoTermsButton(actionLink, label);
  else return investButton(actionLink, label, props);
};

export default LinkView;


const getActionLink = (input) =>
  input.startsWith('tel:') || input.startsWith("http://") || input.startsWith("https://") ? input : "http://" + input;

const isLottoTermsButton = (actionLink) => actionLink.includes("lotto-terms-conditions");
const isInvestPopup = (tags) => tags.some((tag) => tag.code === "invest-popup");

const lottoTermsButton = (actionLink, label) => {
  return (
    <form action={actionLink} target="_blank">
      <input type="submit" value={label} />
    </form>
  );
};

const investButton = (actionLink, label, props) => {
  return (
    <div style={{ textAlign: "center" }}>
      <InvestInput
        className="link-view"
        onClick={() => {
          props.onClickInvestButton(actionLink, props.index);
          isInvestPopup(props.tag) ? null : window.open(actionLink, "_blank");
        }}
      >
        {label}
      </InvestInput>
    </div>
  );
};
